import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface HFMoreLessButtonProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: string
}

const HFMoreLessButton = memo(({templating, children}: HFMoreLessButtonProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName variant="contained" disableRipple disableFocusRipple>
                {children}
            </ComponentName>
        </Suspense>
    )
})
HFMoreLessButton.displayName = "HFMoreLessButton"

export default connect(HFMoreLessButton)
